// Index constants
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;
export const MAX_ROW_ID = 10;
export const ZINDEX = 123;
export const NOT_FOUND_INDEX = -1;

// Store pagination constants
export const STORE_LIMIT = 20;
export const STORE_OFFSET = 0;